const { hmacSha256Hex, sha256Hex } = require('./crypto');

async function hashArtifact(name, content, seed = null) {
  const sha256 = await sha256Hex(content);

  return {
    name,
    bytes: new Blob([content]).size,
    sha256,
    hmacSha256: seed ? await hmacSha256Hex(seed, content) : null
  };
}

async function buildExportIntegrityManifest(artifacts, options = {}) {
  const hashedArtifacts = [];

  for (const artifact of artifacts) {
    hashedArtifacts.push(await hashArtifact(artifact.name, artifact.content, options.seed));
  }

  return {
    manifestType: 'randFlow export integrity manifest',
    manifestVersion: '2.1-operational',
    generatedAt: new Date().toISOString(),
    experimentSignature: options.signature || null,
    hmacNote: options.seed
      ? 'HMAC-SHA-256 is derived from the study seed. Anyone with the seed can recompute it.'
      : 'No HMAC was generated because no seed was provided.',
    verification: 'Recalculate SHA-256 for each exported file and compare with this manifest. Recalculate HMAC only when seed disclosure is acceptable.',
    artifacts: hashedArtifacts
  };
}

function sha256Sidecar(filename, sha256) {
  return `${sha256}  ${filename}\n`;
}

module.exports = {
  buildExportIntegrityManifest,
  hashArtifact,
  sha256Sidecar
};
